import { useEffect } from 'react';
import { isTauri, listen, readRemedy } from '../tauri.js';
import { useStore } from '../store.js';

/**
 * When running inside Tauri, subscribe to the host's `remedy:changed`
 * event and re-read the file into the store. The Rust side emits the
 * event whenever the watched folder's .remedy file is modified, so the
 * editor live-updates without the user touching anything.
 */
export function useTauriWatcher(): void {
  const setSource = useStore((s) => s.setSource);
  const folder = useStore((s) => s.folder);

  useEffect(() => {
    if (!isTauri() || !folder) return;
    let disposed = false;
    let unlisten: (() => void) | null = null;

    (async () => {
      unlisten = await listen<string>('remedy:changed', async (path) => {
        if (disposed) return;
        try {
          const file = await readRemedy(path);
          setSource(file.source, `${folder.name}/.remedy`, folder);
        } catch (e) {
          console.error('useTauriWatcher: reload failed', e);
        }
      });
    })();

    return () => {
      disposed = true;
      unlisten?.();
    };
  }, [folder, setSource]);
}
